export const LIMIT_REQUEST_PARAM = 100;

export const FORM_BUILDER_PARAMS = {
  limit: LIMIT_REQUEST_PARAM,
  visible: true,
  schedulable: true,
};

export const DEFAULT_PARAMS = {
  isRenderingProvider: true,
  visible: true,
  type: 'doctor',
  limit: LIMIT_REQUEST_PARAM,
};

export const TRUE_TIME_PARAMS = {
  ...DEFAULT_PARAMS,
  isReferringProvider: false,
  schedulable: true,
};
